import mapboxgl from 'mapbox-gl';

$(function() {

    const settings = {
        mapboxElement: '.mapbox',
        markerElement: '.mapbox__marker',
        accessToken: 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNrdHNsNHBoYzFiY2oycGw4Y29iNnl2c3YifQ.KgHnvpwO20Fb3xBk0oQ4dw',
        styleLink: 'mapbox://styles/blackdesk/ckps00k5f17e417qo0ugkui3n',
        bigMarkerBackgroundImage: '/wp-content/themes/bijbrigitte/resources/images/mapbox-pinner-big.svg',
        bigMarkerBackgroundImageSize: 200,
        smallMarkerBackgroundImage: '/wp-content/themes/bijbrigitte/resources/images/mapbox-pinner-small.svg',
        smallMarkerBackgroundImageSize: 75,
    };

    const mapbox = $(settings.mapboxElement);
    if (!mapbox.length) {
        return;
    }

    const centerLng = mapbox.data('lng');
    const centerLat = mapbox.data('lat');

    if (!centerLng || !centerLat) {
        return;
    }

    mapboxgl.accessToken = settings.accessToken;
    const map = new mapboxgl.Map({
        container: mapbox.get(0),
        style: settings.styleLink,
        center: new mapboxgl.LngLat(centerLng, centerLat),
        maxZoom: 18,
        zoom: 9,
        minZoom: 6,
    });

    const markers = $(settings.mapboxElement + ' ' + settings.markerElement);
    markers.each(function () {
        const marker = document.createElement('div');
        const markerPosition = new mapboxgl.LngLat($(this).data('lng'), $(this).data('lat'));

        let markerBackgroundImage = '';
        let markerBackgroundImageSize = 0;
        let markerType = $(this).data('marker');

        if (markerType === 'small') {
            markerBackgroundImage = settings.smallMarkerBackgroundImage;
            markerBackgroundImageSize = settings.smallMarkerBackgroundImageSize;
        } else {
            markerBackgroundImage = settings.bigMarkerBackgroundImage;
            markerBackgroundImageSize = settings.bigMarkerBackgroundImageSize;
        }

        marker.className = 'marker';
        marker.style.backgroundImage = 'url(' + markerBackgroundImage + ')';
        marker.style.width = markerBackgroundImageSize + 'px';
        marker.style.height = markerBackgroundImageSize + 'px';
        marker.style.top = '-' + markerBackgroundImageSize / 2 + 'px';
        marker.style.backgroundSize = 'contain';
        marker.style.backgroundRepeat = 'no-repeat';
        marker.style.backgroundPosition = 'center bottom';
        new mapboxgl.Marker(marker).setLngLat(markerPosition).addTo(map);

        // Popup maken
        const html = $(this).html();
        if (html) {
            $(marker).on('click', function (event) {
                event.stopPropagation();
                new mapboxgl.Popup().setLngLat(markerPosition).setHTML(html).addTo(map);
            });
        }
    });
});
